import { render, staticRenderFns } from "./RoamingZoneEdit.vue?vue&type=template&id=27d6da20&scoped=true"
import script from "./RoamingZoneEdit.vue?vue&type=script&lang=ts"
export * from "./RoamingZoneEdit.vue?vue&type=script&lang=ts"
import style0 from "./RoamingZoneEdit.vue?vue&type=style&index=0&id=27d6da20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6da20",
  null
  
)

export default component.exports